import { BIEventPayload } from '@wix/da-bi/pkg/types';
import { AppState } from '../types/store';
import {
  getCurrentOrder,
  getThisTopic,
  getThisGroup,
  getThisTag,
  getThisUser,
  getLayout,
} from './page';
import { getIsCurrentStreamEmpty } from '../selectors/stream';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import { BrowseLayout } from '../../constants';

function getBiView(state: AppState): string {
  if (state.currentPageData?.pageType === 'search') {
    return 'search';
  }
  // all the non-search pages should return 'browse' for view
  return 'browse';
}

function getComponent(state: AppState): string | undefined {
  if (state.currentPageData?.pageType === 'search') {
    const searchType = state.currentPageData?.searchType ?? 'unknown';
    return searchType === 'all' ? 'search_home' : searchType;
  }

  return `${state.currentPageData?.pageType ?? 'home'} ${
    state.currentPageData?.feedType ?? ''
  }`.trim();
}

export function getBiDetails(state: AppState): Partial<BIEventPayload> {
  switch (state.currentPageData?.pageType) {
    case 'groups':
      return {
        typeid: ResourceType.GROUP,
        itemid: getThisGroup(state)?.userId,
        is_empty_state_view: getIsCurrentStreamEmpty(state) ? 1 : 0,
      };
    case 'topic':
      return {
        typeid: getThisTopic(state)?.typeId,
        itemid: getThisTopic(state)?.itemId,
      };
    case 'popular':
      return {
        sort_type: getCurrentOrder(state),
      };
    case 'tag':
      return {
        typeid: getThisTag(state)?.typeId,
        itemid: getThisTag(state)?.itemId,
      };
    case 'watch':
      return {
        typeid: getThisUser(state) ? ResourceType.USER : undefined,
        itemid: getThisUser(state)?.userId,
        view_mode:
          getLayout(state) === BrowseLayout.Stacked ? 'stacked' : 'grid',
        is_empty_state_view: getIsCurrentStreamEmpty(state) ? 1 : 0,
      };
    case 'home':
      return {
        is_empty_state_view: getIsCurrentStreamEmpty(state) ? 1 : 0,
      };
    default:
      return {};
  }
}

export function getPageViewData(state: AppState): BIEventPayload {
  return {
    view: getBiView(state),
    component: getComponent(state),
    metadata: state.currentPageData?.biMetaData,
    ...getBiDetails(state),
  };
}
